/**
 * Who may hold a task.
 *
 * The enforcement is `assertAssignee` in `apps/api/src/routes/entities.ts`,
 * which also checks active status and, for client-side roles, the task's own
 * client. This file answers only the role half, because two callers need just
 * that: the assignment check itself, and the People screen refusing to demote
 * somebody who still holds open work.
 *
 * It is a predicate and not a list so that adding a role is a decision rather
 * than an inheritance.
 */
import type { Role } from './enums.js';

export function canHoldWork(role: Role): boolean {
  return role === 'contractor';
}
